export default __webpack_public_path__ + "9094ce7.png";